import { render, staticRenderFns } from "./EditPaymentTypeDialog.vue?vue&type=template&id=5c3ec99a"
import script from "./EditPaymentTypeDialog.vue?vue&type=script&lang=js"
export * from "./EditPaymentTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports